/**
 * Positioning utilities for absolute-positioned components.
 * Everything is a multiple of 4 to coincide with the spacing utilities.
 */
export default {
    pRelative: {
        position: 'relative',
    },
    pAbsolute: {
        position: 'absolute',
    },
    t0: {
        top: 0,
    },
    tn4: {
        top: -16,
    },
    tn8: {
        top: -32,
    },
    l0: {
        left: 0,
    },
    l4: {
        left: 4,
    },
    r0: {
        right: 0,
    },
    r4: {
        right: 16,
    },
    b0: {
        bottom: 0,
    },
};
